import axios from 'axios';

import { apiSlice } from '../../api';
import type {
  GetReportBlobDTO,
  GetReportBlobResult,
  GetReportsDTO,
  GetReportsResult,
} from './types';

export const adminReportsEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => {
    return {
      getReports: build.query<GetReportsResult, GetReportsDTO>({
        query: () => ({
          url: '/admin/v1/reports',
          method: 'GET',
        }),
      }),
    };
  },
});

export const { useGetReportsQuery, useLazyGetReportsQuery } = adminReportsEndpoints;

export type AdminReportsController = typeof adminReportsEndpoints;

// separate request for fetching report's blob (without using rtk-query for performance)
export const getReportBlob = ({ report_type, params }: GetReportBlobDTO) => {
  return axios.get<GetReportBlobResult>(`/admin/v1/reports/${report_type}?response_type=CSV`, {
    params,
    responseType: 'blob',
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: 180000,
    withCredentials: true,
  });
};
